import React from "react";
import { isPhone, SelectDropdown } from "@cadmakers-ui/core";
import { Dropdown, DropdownToggle, DropdownItem, DropdownMenu, Row, Col } from "reactstrap";
import { FeedbackPriority } from "../../../Constants/feedbackEnums";
import styles from "../../../Styles/FeedbackPrioritySetter.module.scss";

type Props = {
  selectedPriority?: FeedbackPriority;
  priorityOptions: FeedbackPriority[];
  includeLabel: boolean;
  isReadOnly: boolean;
  onSelectPriority: (priority: FeedbackPriority) => void;
};

type State = {
  isDropdownOpen: boolean;
};

export default class FeedbackPrioritySetter extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isDropdownOpen: false
    };

    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  getTextForPriority(p?: FeedbackPriority) {
    let desc = "";

    switch (p) {
      case FeedbackPriority.VeryLow:
        desc = "Very Low";
        break;
      case FeedbackPriority.Low:
        desc = "Low";
        break;
      case FeedbackPriority.Medium:
        desc = "Medium";
        break;
      case FeedbackPriority.High:
        desc = "High";
        break;
      case FeedbackPriority.VeryHigh:
        desc = "Very High";
        break;
      default:
        desc = "";
    }

    return p ? `${p.toString()}: ${desc}` : "Unset";
  }

  toggleDropdown() {
    this.setState((prevState: State) => ({
      isDropdownOpen: !prevState.isDropdownOpen
    }));
  }

  render() {
    const selectedPriorityText = this.getTextForPriority(this.props.selectedPriority);

    const priorityLabelClassName = `btn btn-secondary ${styles.label}`;

    const dropdownOptions = this.props.priorityOptions.map(el => ({
      value: el,
      label: this.getTextForPriority(el)
    }));

    return (
      <div className={styles.feedbackPrioritySetterContainer}>
        {this.props.includeLabel && (
          <button type="button" className={priorityLabelClassName} disabled>
            Priority
          </button>
        )}
        <div style={{ width: "80px", display: "inline-block" }} onClick={e => e.stopPropagation()}>
          <SelectDropdown
            options={dropdownOptions}
            value={{
              value: this.props.selectedPriority ? this.props.selectedPriority : 0,
              label: this.props.selectedPriority ? this.props.selectedPriority.toString() : "?"
            }}
            onChange={v => this.props.onSelectPriority((v as any).value)}
            isSearchable={false}
          />
        </div>
      </div>
    );
  }
}
